// Copyright (c) Docugami, Inc. All rights reserved.

export class StringBuilder {
    data: string[];
    counter: number;

    constructor()
    {
        this.data = [];
        this.counter = 0;
    }

    appendLine(line: string)
    {
        this.data[this.counter += 1] = line + '\n';
    }

    append(line: string)
    {
        this.data[this.counter += 1] = line;
    }

    toString()
    {
        return this.data.join('');
    }
}
